import { DoughnutColors, GiaMark, GiaType } from 'const';
import { accentColors } from 'portfolio3/styles';

import { getProgressValue } from './doughnut';

type ExamData = {
  formaGia: string;
  approbation?: boolean;
  normalizedMarkValue: string | number | null;
  normalizedMarkBasis?: string | number | null;
  percentMarkValue?: number | null;
  positiveResultThreshold?: number;
  isCredit?: boolean;
};

const red = accentColors.red[100];
const yellow = accentColors.yellow[100];
const green = accentColors.green[100];

const TEST_HINT = 'тестовый балл';
const PERCENT_HINT = '% выполнения';

export const getExamDoughnutData = ({
  formaGia,
  approbation,
  normalizedMarkValue,
  normalizedMarkBasis,
  percentMarkValue,
  positiveResultThreshold,
  isCredit,
}: ExamData) => {
  // график
  let doughnutTotal: string | number | null | undefined =
    approbation && normalizedMarkValue === null ? percentMarkValue : normalizedMarkValue;

  let doughnutValue = 0;
  let doughnutColor = DoughnutColors.GRAY;

  if (normalizedMarkBasis) {
    const normalizedMarkValueNumber =
      approbation && normalizedMarkValue === null ? percentMarkValue ?? 0 : Number(normalizedMarkValue);
    const normalizedMarkBasisNumber = Number(normalizedMarkBasis);

    doughnutValue = normalizedMarkBasis
      ? getProgressValue(normalizedMarkValueNumber, normalizedMarkBasisNumber)
      : normalizedMarkValueNumber;

    if (formaGia === GiaType.ege && positiveResultThreshold) {
      if (doughnutValue < positiveResultThreshold) {
        doughnutColor = red;
      }
      if (doughnutValue >= positiveResultThreshold && doughnutValue < 90) {
        doughnutColor = yellow;
      }
      if (doughnutValue >= 90) {
        doughnutColor = green;
      }
    } else {
      doughnutColor = red;
      if (normalizedMarkValueNumber === 4) doughnutColor = yellow;
      if (normalizedMarkValueNumber === 5) doughnutColor = green;
    }
  }

  if (normalizedMarkValue === GiaMark.passed) {
    doughnutTotal = GiaMark.passedAbbreviation;
    doughnutValue = 100;
    doughnutColor = green;
  }
  if (normalizedMarkValue === GiaMark.notPassed) {
    doughnutTotal = GiaMark.notPassedAbbreviation;
    doughnutValue = 100;
    doughnutColor = red;
  }
  // exam_form_ref 4-6
  const isCreditFormaGiaTypes = [GiaType.writing, GiaType.narration, GiaType.interviewRus];
  if (isCreditFormaGiaTypes.includes(formaGia) && Boolean(isCredit)) {
    if (normalizedMarkValue === '1') {
      doughnutTotal = 'Зч';
      doughnutColor = green;
    } else {
      doughnutTotal = 'Нзч';
      doughnutColor = red;
    }
    doughnutValue = 100;
  }

  const doughnutData = {
    incomingData: [doughnutValue, 100 - doughnutValue],
    incomingLabels: ['1', '2'],
  };

  // настройка подсказки под кругом
  let lowerHint = '';
  const isRealExam = [GiaType.gve11, GiaType.ege, GiaType.oge, GiaType.gve9].includes(formaGia);
  if (!isCredit) {
    if ((!approbation && isRealExam) || (approbation && GiaType.oge === formaGia)) {
      lowerHint = TEST_HINT;
    }
    if (approbation && GiaType.ege === formaGia) {
      lowerHint = normalizedMarkValue === null && percentMarkValue !== null ? PERCENT_HINT : TEST_HINT;
      doughnutTotal = `${doughnutTotal}${percentMarkValue !== null ? '%' : ''}`;
    }
  }

  return {
    doughnutTotal,
    doughnutData,
    doughnutColor,
    lowerHint,
  };
};
